export default {
  id: 'quickbooks',
  title: 'QuickBooks Integration',
  category: 'Admin',
  summary: 'Map Timeclerk customers, contracts, projects, charge codes, and payroll expenses to QuickBooks, and review synced transactions.',
  overview: 'QuickBooks integration links Timeclerk commercial and payroll data to QuickBooks accounting objects so invoices and expenses post correctly.',
  howItWorks: [
    'Entity mapping pages pair Timeclerk records with QuickBooks counterparts.',
    'Transaction views show what has been synced or needs attention.',
    'Payroll expense mapping controls how payroll costs land in the chart of accounts.'
  ],
  actions: [
    {
      name: 'Map an entity',
      description: 'Associates a Timeclerk customer, contract, project, charge code, or payroll expense with a QuickBooks record.'
    },
    {
      name: 'Review transactions',
      description: 'Inspect synced transactions and open details when troubleshooting posting issues.'
    }
  ],
  tips: [
    'Map customers and contracts before expecting invoice sync to succeed.',
    'Revisit mappings after creating new projects or charge codes.'
  ],
  related: ['integrations', 'invoices', 'payroll']
};



// WEBPACK FOOTER //
// ./client/help/content/quickbooks.js